
/*
 * Build a /cart/add.js JSON payload from a FormData object.
 *
 * The product form uses `items[][id]`, `items[][quantity]` and
 * `items[][properties][...]` inputs. Because the quantity input lives
 * outside the <form> (linked via the `form` attribute), FormData walks the
 * DOM in tree order and emits the fields as
 *   items[][quantity]=1&items[][id]=X&items[][properties][...]=
 * Shopify's /cart/add.js parser then treats each `items[]` occurrence as a
 * new array entry, producing [{quantity:"1"}, {id:"X"}, ...] and a 400
 * response. Grouping the entries here and posting JSON guarantees a single
 * well-formed item per product regardless of input order.
 */
window.serializeCartAddPayload = function (formData) {
  const items = [];
  const top = {};
  let current = null;

  const hasField = (item, field, sub) => {
    if (!item) return false;
    if (sub) {
      return item[field] && Object.prototype.hasOwnProperty.call(item[field], sub);
    }
    return Object.prototype.hasOwnProperty.call(item, field);
  };

  for (const [key, value] of formData.entries()) {
    const match = key.match(/^items\[\]\[([^\]]+)\](?:\[([^\]]+)\])?$/);
    if (!match) {
      top[key] = value;
      continue;
    }
    const field = match[1];
    const sub = match[2];

    if (!current || hasField(current, field, sub)) {
      if (current) items.push(current);
      current = {};
    }

    if (sub) {
      if (!current[field]) current[field] = {};
      current[field][sub] = value;
    } else if (field === 'quantity') {
      const parsed = parseInt(value, 10);
      current[field] = Number.isFinite(parsed) && parsed > 0 ? parsed : 1;
    } else {
      current[field] = value;
    }
  }
  if (current) items.push(current);

  return Object.assign({}, top, { items });
};

if (!customElements.get('variant-selects')) {

  /**
   *  @class
   *  @function VariantSelects
   */
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.sticky = this.dataset.sticky;
      this.updateUrl = this.dataset.updateUrl === 'true';
      this.isDisabledFeature = this.dataset.isDisabled;
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.thb-product-detail');
      this.productSlider = this.productWrapper.querySelector('.product-images');
      this.hideVariants = this.dataset.hideVariants === 'true';
      this.isVariantLoop = this.querySelector('fieldset[data-variant-loop="true"]') ? true : false;
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      (!this.isVariantLoop) && this.setDisabled();
      this.setImageSet();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.removeErrorMessage();
      this.updateVariantText();
      (!this.isVariantLoop) && this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        if (this.updateUrl) {
          this.updateURL();
        }
        this.updateVariantAddOns();
        this.updateVariantInput();
        this.renderProductInfo();
        //this.updateShareUrl();
      }

      this.updateOther();
      dispatchCustomEvent('product:variant-change', {
        variant: this.currentVariant,
        sectionId: this.dataset.section
      });
    }

    updateVariantAddOns() {
      console.log('steste');
      var mainProductInfo = this.closest('.product-information');
      if (mainProductInfo != null) {
        var varAddOns = mainProductInfo.querySelectorAll('product-recommendations .variant-metafield-addon');
        if (varAddOns.length > 0) {
          const rec = mainProductInfo.querySelector('product-recommendations');
          varAddOns.forEach(item => item.classList.add('d-none'));
          rec.setupVariantAddons();
        }
      }
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = [];
      this.fieldsets.forEach((fieldset, i) => {
        if (fieldset.getAttribute('data-variant-loop') == "true") {
          var selectedInput = fieldset.querySelector('input:checked')?.getAttribute('data-var-options') || fieldset.querySelector('select')?.value;
          this.options = JSON.parse(selectedInput);
        } else {
          if (fieldset.querySelector('select')) {
            this.options.push(fieldset.querySelector('select').value);
          } else if (fieldset.querySelectorAll('input').length) {
            this.options.push(fieldset.querySelector('input:checked').value);
          }
        }
        fieldset?.querySelector('[data-option-err]')?.classList.add('d-none');
      });
    }
    updateVariantText() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach((item, i) => {
        var label = item.querySelector('.form__label__value');
        if (item.getAttribute('data-variant-loop') == "true") {
          if (label) { label.innerHTML = item.querySelector('input:checked').value; }
        } else {
          if (label) { label.innerHTML = this.options[i]; }
        }
      });
    }
    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateOther() {
      if (this.dataset.updateUrl === 'false') {
        return;
      }
      if (this.other.length) {
        let fieldsets = this.other[0].querySelectorAll('fieldset'),
          fieldsets_array = Array.from(fieldsets);
        this.options.forEach((option, i) => {
          if (fieldsets_array[i].querySelector('select')) {
            fieldsets_array[i].querySelector(`select`).value = option;
          } else if (fieldsets_array[i].querySelectorAll('input').length) {
            fieldsets_array[i].querySelector(`input[value='${option}']`).checked = true;
          }
        });
        this.other[0].updateOptions();
        this.other[0].updateMasterId();
        this.other[0].updateVariantText();
        (!this.isVariantLoop) && this.other[0].setDisabled();
      }
    }

    async updateMedia() {
      console.log(this.currentVariant);
      var el = document.querySelector(`[data-main-pdp-image-slider] .product-images-wrappers`);
      var variantSlider = document.querySelector(`[data-main-pdp-image-slider] [data-variant-slider="${this.currentVariant.id}"]`);
      if(!variantSlider) {
        var product_handle = document.querySelector(`[data-main-pdp-image-slider]`)?.getAttribute('data-pdp-handle');
        const res = await fetch(`/products/${product_handle}?variant=${this.currentVariant.id}&view=variant-images`);
        const html = await res.text();
        if (el) {
          el.insertAdjacentHTML('beforeend', html);
        }
      }

      // update variant badges
      const allVarBadges = document.querySelectorAll('[data-variant-badges]');
      allVarBadges.forEach(item => item.classList.add('d-none'));
      document.querySelectorAll(`[data-variant-badges="${this.currentVariant.id}"]`).forEach(item => item.classList.remove('d-none'))
      
      // get active image index
      var activeImageSelector = el?.querySelector(`[data-variant-slider]:not(.d-none)`) || el?.querySelector(`[data-main-product-slider]:not(.d-none)`);
      if (activeImageSelector) {
        var imageSliderArray = activeImageSelector.querySelectorAll('.product-images__slide');
        var index = Array.from(imageSliderArray).findIndex(element => element.classList.contains('is-selected'));
        console.log(index);
      }

      if (el?.querySelector(`[data-variant-slider="${this.currentVariant.id}"] product-slider img`)) {
        el?.querySelectorAll(`[data-variant-slider]`).forEach(el => el.classList.add('d-none'))
        el?.querySelectorAll(`[data-main-product-slider]`).forEach(el => el.classList.add('d-none'))
        el?.querySelectorAll(`[data-variant-slider="${this.currentVariant.id}"]`).forEach(el => el.classList.remove('d-none'));
        el?.querySelector(`[data-variant-slider="${this.currentVariant.id}"] product-slider`)?.classList.add('shadow') 

        // activated the perfect index
        var thumbnailIndexs = el?.querySelectorAll(`[data-variant-slider="${this.currentVariant.id}"] .product-thumbnail-wrapper .product-images__slide-item--variant`);
        if(thumbnailIndexs != null) {
          setTimeout(() => {
            thumbnailIndexs[index]?.dispatchEvent(new Event('click'));
          }, 10);
        }
      } else {
        el?.querySelectorAll(`[data-variant-slider]`).forEach(el => el.classList.add('d-none'))
        el?.querySelectorAll(`[data-main-product-slider]`).forEach(el => el.classList.remove('d-none'))

        // activated the perfect index
        var thumbnailIndexs = el?.querySelectorAll(`[data-main-product-slider] .product-thumbnail-wrapper .product-images__slide-item--variant`);
        if(thumbnailIndexs != null) {
          setTimeout(() => {
            thumbnailIndexs[index]?.dispatchEvent(new Event('click'));
          }, 10);
        }
      }
      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);

      // if (!this.currentVariant) return;
      // if (!this.currentVariant.featured_media) return;

      // let thumbnails = this.productWrapper.querySelector('.product-thumbnail-container');

      // this.setActiveMedia(`#Slide-${this.dataset.section}-${this.currentVariant.featured_media.id}`, `#Thumb-${this.dataset.section}-${this.currentVariant.featured_media.id}`, this.productSlider, thumbnails);
    }
    setActiveMedia(mediaId, thumbId, productSlider, thumbnails) {
      let flkty = Flickity.data(productSlider),
        activeMedia = productSlider.querySelector(mediaId);

      if (flkty && this.hideVariants) {


        if (productSlider.querySelector('.product-images__slide.is-initial-selected')) {
          productSlider.querySelector('.product-images__slide.is-initial-selected').classList.remove('is-initial-selected');
        }
        [].forEach.call(productSlider.querySelectorAll('.product-images__slide-item--variant'), function (el) {
          el.classList.remove('is-active');
        });

        activeMedia.classList.add('is-active');
        activeMedia.classList.add('is-initial-selected');

        this.setImageSetMedia();

        if (thumbnails) {
          let activeThumb = thumbnails.querySelector(thumbId);

          if (thumbnails.querySelector('.product-thumbnail.is-initial-selected')) {
            thumbnails.querySelector('.product-thumbnail.is-initial-selected').classList.remove('is-initial-selected');
          }
          [].forEach.call(thumbnails.querySelectorAll('.product-images__slide-item--variant'), function (el) {
            el.classList.remove('is-active');
          });

          activeThumb.classList.add('is-active');
          activeThumb.classList.add('is-initial-selected');
        }

        productSlider.reInit(this.imageSetIndex);
        productSlider.selectCell(mediaId);

      } else if (flkty) {
        productSlider.selectCell(mediaId);
      }

    }

    updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
        const input = productForm.querySelector('input[name="items[][id]"]');
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
      const allAddProducts = document.querySelectorAll('input[name="items[][properties][_isAddonVariantId]"]');
      allAddProducts.forEach(input => {
        input.value = this.currentVariant.id;
      })
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('.pickup-availability-wrapper');

      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}`, `price-${this.dataset.section}--sticky`, `product-image-${this.dataset.section}--sticky`, `inventory-${this.dataset.section}`, `sku-${this.dataset.section}`, `quantity-${this.dataset.section}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();
      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = html.getElementById(id);

            if (source && destination) destination.innerHTML = source.innerHTML;

            const price = document.getElementById(id);
            const price_fixed = document.getElementById(id + '--sticky');

            if (price) price.classList.remove('visibility-hidden');
            if (price_fixed) price_fixed.classList.remove('visibility-hidden');

          });
          var btnString = window.theme.variantStrings.soldOut;
          if (document.querySelector('hubspot-form#Product-Newsletter-Drawer')) {
            btnString = window.theme.variantStrings.notify_me;
          }
          this.toggleAddButton(!this.currentVariant.available, btnString);

        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;

      const productTemplate = productForm.closest('.product-form').getAttribute('template');
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');

      if (!submitButtons) return;
      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');

        if (!submitButtonText) return;
        if (disable) {
          submitButton.setAttribute('disabled', 'disabled');
          if (text) submitButtonText.textContent = text;
        } else {
          submitButton.removeAttribute('disabled');
          submitButton.classList.remove('loading');

          if (productTemplate?.includes('pre-order')) {
            submitButtonText.textContent = window.theme.variantStrings.preOrder;
          } else {
            if (this.dataset.comingSoon == 'true') {
              submitButtonText.textContent = window.theme.variantStrings.notify_me;
            } else {
              submitButtonText.textContent = window.theme.variantStrings.addToCart;
            }
          }

        }
      });

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButtons = document.querySelectorAll('.single-add-to-cart-button');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const price_fixed = document.getElementById(`price-${this.dataset.section}--sticky`);

      submitButtons.forEach((submitButton) => {
        const submitButtonText = submitButton.querySelector('.single-add-to-cart-button--text');
        if (!submitButton) return;
        submitButtonText.textContent = window.theme.variantStrings.unavailable;
        submitButton.classList.add('sold-out');
      });
      if (price) price.classList.add('visibility-hidden');
      if (price_fixed) price_fixed.classList.add('visibility-hidden');
    }

    setDisabled() {
      if (this.isDisabledFeature != 'true') {
        return;
      }
      const variant_data = this.getVariantData();


      if (variant_data) {

        let selected_options = false;
        if (this.currentVariant) {
          selected_options = this.currentVariant.options.map((value, index) => {
            return {
              value,
              index: `option${index + 1}`
            };
          });
        } else {
          let found_option = variant_data.find(option => {
            return option.option1 === this.options[0];
          });
          if (found_option) {
            selected_options = [
              {
                "value": this.options[0],
                "index": "option1"
              },
              {
                "value": found_option.option2,
                "index": "option2"
              }
            ];
          } else {
            return;
          }
        }
        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];

          if (fieldset_options) {
            if (fieldset.querySelector('select')) {
              fieldset_options.forEach((option, option_i) => {
                if (option.isUnavailable) {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = true;
                } else {
                  fieldset.querySelector('option[value=' + JSON.stringify(option.value) + ']').disabled = false;
                }
              });
            } else if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i] ? fieldset_options[input_i].isUnavailable : true);
              });
            }
          }
        });

      }
      return true;
    }

    getImageSetName(variant_name) {
      return variant_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
    }

    async setImageSet() {
      if (!this.productSlider) return;
      let dataSetEl = this.productSlider.querySelector('[data-set-name]');
      if (dataSetEl) {
        this.imageSetName = dataSetEl.dataset.setName;
        this.imageSetIndex = this.querySelector('.product-form__input[data-handle="' + this.imageSetName + '"]').dataset.index;
        this.dataset.imageSetIndex = this.imageSetIndex;
        this.setImageSetMedia();
      }
    }
    setImageSetMedia() {
      if (!this.imageSetIndex) {
        return;
      }

      let setValue = this.getImageSetName(this.currentVariant[this.imageSetIndex]);
      let group = this.imageSetName + '_' + setValue;
      let selected_set_images = this.productWrapper.querySelectorAll(`.product-images__slide[data-set-name="${this.imageSetName}"]`),
        selected_set_thumbs = this.productWrapper.querySelectorAll(`.product-thumbnail[data-set-name="${this.imageSetName}"]`);

      if (this.hideVariants) {
        // Product images
        this.productWrapper.querySelectorAll('.product-images__slide').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_images.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });

        // Product thumbnails
        this.productWrapper.querySelectorAll('.product-thumbnail').forEach(thumb => {
          if (thumb.dataset.group && thumb.dataset.group !== group) {
            thumb.classList.remove('is-active');
          }
        });
        selected_set_thumbs.forEach(thumb => {
          thumb.classList.toggle('is-active', thumb.dataset.group === group);
        });
      }

    }

    createAvailableOptionsTree(variants, currentlySelectedValues) {
      // Reduce variant array into option availability tree
      return variants.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = { value: variant[index], isUnavailable: true };
            options[index].push(entry);
          }

          const currentOption1 = currentlySelectedValues.find(({ value, index }) => index === 'option1');
          const currentOption2 = currentlySelectedValues.find(({ value, index }) => index === 'option2');

          switch (index) {
            case 'option1':
              // Option1 inputs should always remain enabled based on all available variants
              entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              break;
            case 'option2':
              // Option2 inputs should remain enabled based on available variants that match first option group
              if (currentOption1 && variant.option1 === currentOption1.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
              break;
            case 'option3':
              // Option 3 inputs should remain enabled based on available variants that match first and second option group
              if (currentOption1 && variant.option1 === currentOption1.value && currentOption2 && variant.option2 === currentOption2.value) {
                entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
              }
          }
        });

        return options;
      }, { option1: [], option2: [], option3: [] });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }
  customElements.define('variant-selects', VariantSelects);

  /**
   *  @class
   *  @function VariantRadios
   */
  class VariantRadios extends VariantSelects {
    constructor() {
      super();
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
    }
  }

  customElements.define('variant-radios', VariantRadios);
}

if (!customElements.get('product-slider')) {
  /**
   *  @class
   *  @function ProductSlider
   */
  class ProductSlider extends HTMLElement {
    constructor() {
      super();

      this.count = 0;
      this.addEventListener('change', this.setupProductGallery);
    }
    connectedCallback() {
      this.product_container = this.closest('.thb-product-detail');
      this.thumbnail_container = this.closest('.bundle-variant-slider-wrapper') ? this.closest('.bundle-variant-slider-wrapper')?.querySelector('.product-thumbnail-container') : this.product_container.querySelector('.product-thumbnail-container');
      if (!this.thumbnail_container && this.count <= 5) {
        setTimeout(() => {
          this.connectedCallback();
          this.count++;
        }, 1000);
        console.log(this.count);
        return false;
      };
      this.video_containers = this.querySelectorAll('.product-single__media-external-video--play');

      this.setOptions();
      // Start Slider
      this.init();
    }
    setOptions() {
      this.hide_variants = this.dataset.hideVariants == 'true';
      this.thumbnails = this.thumbnail_container?.querySelectorAll('.product-thumbnail');
      this.prev_button = this.closest('.product-image-container')?.querySelector('.flickity-prev');
      this.next_button = this.closest('.product-image-container')?.querySelector('.flickity-next');
      this.options = {
        wrapAround: true,
        pageDots: true,
        contain: true,
        adaptiveHeight: true,
        initialIndex: '.is-initial-selected',
        prevNextButtons: false,
        fade: false,
        cellSelector: '.product-images__slide.is-active'
      };
    }
    init() {
      this.flkty = new Flickity(this, this.options);

      this.selectedIndex = this.flkty.selectedIndex;

      // Setup Events
      this.setupEvents();

      // Start Gallery
      this.setupProductGallery();
    }
    reInit(imageSetIndex) {

      this.flkty.destroy();

      this.setOptions();

      this.flkty = new Flickity(this, this.options);

      // Setup Events
      this.setupEvents();

      this.selectedIndex = this.flkty.selectedIndex;
    }
    setupEvents() {
      const _this = this;
      if (this.prev_button) {
        let prev = this.prev_button.cloneNode(true);
        this.prev_button.parentNode.append(prev);
        this.prev_button.remove();
        prev.addEventListener('click', (event) => {
          this.flkty.previous();
        });
        prev.addEventListener('keyup', (event) => {
          this.flkty.previous();
          event.preventDefault();
        });
      }
      if (this.next_button) {
        let next = this.next_button.cloneNode(true);
        this.next_button.parentNode.append(next);
        this.next_button.remove();
        next.addEventListener('click', (event) => {
          this.flkty.next();
        });
        next.addEventListener('keyup', (event) => {
          this.flkty.next();
          event.preventDefault();
        });
      }
      this.video_containers.forEach((container) => {
        container.querySelector('button').addEventListener('click', function () {
          container.setAttribute('hidden', '');
        });
      });
      this.flkty.on('settle', function (index) {
        _this.selectedIndex = index;
      });
      this.flkty.on('change', (index) => {

        let previous_slide = this.flkty.cells[_this.selectedIndex].element,
          previous_media = previous_slide.querySelector('.product-single__media'),
          active_thumbs = Array.from(this.thumbnails).filter(element => element.classList.contains('is-active')),
          active_thumb = active_thumbs[index] ? active_thumbs[index] : active_thumbs[0];

        this.thumbnails.forEach((item, i) => {
          item.classList.remove('is-initial-selected');
        });
        active_thumb.classList.add('is-initial-selected');

        requestAnimationFrame(() => {
          if (active_thumb.offsetParent === null) {
            return;
          }
          const windowHalfHeight = active_thumb.offsetParent.clientHeight / 2,
            windowHalfWidth = active_thumb.offsetParent.clientWidth / 2;
          active_thumb.parentElement.scrollTo({
            left: active_thumb.offsetLeft - windowHalfWidth + active_thumb.clientWidth / 2,
            top: active_thumb.offsetTop - windowHalfHeight + active_thumb.clientHeight / 2,
            behavior: 'smooth'
          });
        });

        // Stop previous video
        if (previous_media.classList.contains('product-single__media-external-video')) {
          if (previous_media.dataset.provider === 'youtube') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              event: "command",
              func: "pauseVideo",
              args: ""
            }), "*");
          } else if (previous_media.dataset.provider === 'vimeo') {
            previous_media.querySelector('iframe').contentWindow.postMessage(JSON.stringify({
              method: "pause"
            }), "*");
          }
          previous_media.querySelector('.product-single__media-external-video--play').removeAttribute('hidden');
        } else if (previous_media.classList.contains('product-single__media-native-video')) {
          previous_media.querySelector('video').pause();
        }

      });


      setTimeout(() => {
        let active_thumbs = Array.from(this.thumbnails).filter(element => element.clientWidth > 0);
        active_thumbs.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', () => {
            this.thumbnailClick(thumbnail, index);
          });
        });
      });

    }
    thumbnailClick(thumbnail, index) {
      [].forEach.call(this.thumbnails, function (el) {
        el.classList.remove('is-initial-selected');
      });
      thumbnail.classList.add('is-initial-selected');
      this.flkty.select(index);
    }
    setDraggable(draggable) {
      this.flkty.options.draggable = draggable;
      this.flkty.updateDraggable();
    }
    selectCell(mediaId) {
      this.flkty.selectCell(mediaId);
    }
    setupProductGallery() {
      if (!this.querySelectorAll('.product-single__media-zoom').length) {
        return;
      }
      this.setEventListeners();
    }
    buildItems() {
      this.activeImages = Array.from(this.querySelectorAll('.product-images__slide.is-active .product-single__media-image'));

      return this.activeImages.map((item) => {
        let index = [].indexOf.call(item.parentNode.parentNode.children, item.parentNode);

        let activelink = item.querySelector('.product-single__media-zoom');

        activelink.dataset.index = index;
        return {
          src: activelink.getAttribute('href'),
          msrc: activelink.dataset.msrc,
          w: activelink.dataset.w,
          h: activelink.dataset.h
        };
      });
    }
    setEventListeners() {
      this.links = this.querySelectorAll('.product-single__media-zoom');
      this.pswpElement = document.querySelectorAll('.pswp')[0];
      this.pswpOptions = {
        maxSpreadZoom: 2,
        loop: false,
        allowPanToNext: false,
        closeOnScroll: false,
        showHideOpacity: false,
        arrowKeys: true,
        history: false,
        captionEl: false,
        fullscreenEl: false,
        zoomEl: false,
        shareEl: false,
        counterEl: true,
        arrowEl: true,
        preloaderEl: true,
        getThumbBoundsFn: () => {
          const thumbnail = this.querySelector('.product-images__slide.is-selected'),
            pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return {
            x: rect.left,
            y: rect.top + pageYScroll,
            w: rect.width
          };
        }
      };


      this.links.forEach((link => {
        link.addEventListener('click', (e) => this.zoomClick(e, link));
      }));
    }
    zoomClick(e, link) {
      this.items = this.buildItems();
      this.pswpOptions.index = parseInt(link.dataset.index, 10);
      if (typeof PhotoSwipe !== 'undefined') {
        let pswp = new PhotoSwipe(this.pswpElement, PhotoSwipeUI_Default, this.items, this.pswpOptions);
        pswp.listen('firstUpdate', function () {
          pswp.listen('parseVerticalMargin', function (item) {
            item.vGap = {
              top: 50,
              bottom: 50
            };
          });
        });
        pswp.init();
      }
      e.preventDefault();
    }
  }
  customElements.define('product-slider', ProductSlider);
}

/**
 *  @class
 *  @function ProductForm
 */
if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.sticky = this.dataset.sticky;
      this.form = document.getElementById(`product-form-${this.dataset.section}`);
      this.form.querySelector('[name="items[][id]"]').disabled = false;
      if (!this.sticky) {
        this.form.addEventListener('submit', this.checkAtcFeasibility.bind(this));
        this.form.addEventListener('final:submit', this.onSubmitHandler.bind(this));
      }
      this.cartNotification = document.querySelector('cart-notification');
      this.body = document.body;

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    checkAtcFeasibility (event) {
      event.preventDefault();
      const dropdowns = event.target.closest('.product-information')?.querySelectorAll('.product-form__input--dropdown select');
      var validForm = true;
      if (dropdowns.length) {
        dropdowns.forEach((ele)=>{
          if (ele.value == 'false') {
            validForm = false;
            ele.closest('fieldset')?.querySelector('[data-option-err]')?.classList.remove('d-none');
          }else{
            ele.closest('fieldset')?.querySelector('[data-option-err]')?.classList.add('d-none');
          }
        })
      }
      if(!validForm) return false;
      var skipCompatibility = document.querySelector('year-make-model#GlobalYmmModel') ? false : true;
      window.activeProductDataSectionId = this.getAttribute('data-section');
      if (!this.closest('#Product-Drawer') && !this.closest('.card-item') && !skipCompatibility && !window.jsProduct.tags.includes('Universal')) {
        var varId = this.form.querySelector('[name="items[][id]"]').value;
        var isExist = theme.globalVariable.cart.items.some(item => item.id === parseInt(varId));
        if(window.isProductCompatible == "No Data") {
          document.querySelector('model-component#NotSelected')?.classList.add('active');
          document.body.classList.add('open-cc--product');
        } else {
          if (isExist) {
            document.querySelector('model-component#AlreadyInCart')?.classList.add('active');
            document.body.classList.add('open-cc--product');
          } else {
            if (window.isProductCompatible == true) {
              // this.onSubmitHandler(event);
              window.checkWarrantyModel(this.form);
            } else {
              document.querySelector('model-component#NotCompatible')?.classList.add('active');
              document.body.classList.add('open-cc--product');
            }
          } 
        }
      } else {
        window.checkWarrantyModel(this.form);
        // this.onSubmitHandler(event);
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (!this.form.reportValidity()) {
        return;
      }
      if (this.closest('.card-item')) {
        var validForm = true;
      } else {
        const dropdowns = evt.target.closest('.product-information')?.querySelectorAll('.product-form__input--dropdown select');
        var validForm = true;
        if (dropdowns.length) {
          dropdowns.forEach((ele)=>{
            if (ele.value == 'false') {
              validForm = false;
              ele.closest('fieldset')?.querySelector('[data-option-err]')?.classList.remove('d-none');
            }else{
              ele.closest('fieldset')?.querySelector('[data-option-err]')?.classList.add('d-none');
            }
          })
        }
      }
      if (validForm != false) {
        const submitButtons = this.querySelectorAll('.single-add-to-cart-button');

        submitButtons.forEach((submitButton) => {
          if (submitButton.classList.contains('loading')) return;
          submitButton.setAttribute('aria-disabled', true);
          submitButton.classList.add('loading');
        });

        var inputVal = this.form.querySelector('[name="items[][id]"]').value;
        const allAddProducts = document.querySelectorAll('input[name="items[][properties][_isAddonVariantId]"]');
        allAddProducts.forEach(input => {
          input.value = inputVal;
        })

        const notSelectedVehicleName = document.querySelector('[data-selected-vehicle="name"]');
        const allProductData = document.querySelectorAll('input[name="items[][properties][Selected for]"]');
        if (notSelectedVehicleName) {
          allProductData?.forEach(item => (item.value = notSelectedVehicleName?.innerHTML)) 
        } else {
          allProductData?.forEach(item => (item.setAttribute('disabled','disabled'))) 
        }

        this.handleErrorMessage();

        let formData = new FormData(this.form);
        const payload = window.serializeCartAddPayload(formData);
        payload.sections = this.getSectionsToRender().map((section) => section.section);
        payload.sections_url = window.location.pathname;

        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/javascript',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        };

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              dispatchCustomEvent('product:variant-error', {
                source: 'product-form',
                productVariantId: payload.items && payload.items[0] ? payload.items[0].id : undefined,
                errors: response.description,
                message: response.message
              });
              this.handleErrorMessage(response.description);
              return;
            }
  
            this.renderContents(response);
  
            dispatchCustomEvent('cart:item-added', {
              product: response.hasOwnProperty('items') ? response.items[0] : response
            });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            submitButtons.forEach((submitButton) => {
              submitButton.classList.remove('loading');
              submitButton.removeAttribute('aria-disabled');
            });
          });
      }
    }

    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));



      let product_drawer = document.getElementById('Product-Drawer'),
        search_drawer = document.getElementById('Search-Drawer');

      if (search_drawer.classList.contains('active')) {
        search_drawer.classList.remove('active');
      }
      if (product_drawer && product_drawer.contains(this)) {
        product_drawer.classList.remove('active');
        this.body.classList.remove('open-cc--product');
        if (document.getElementById('Cart-Drawer')) {
          this.body.classList.add('open-cc');
          document.getElementById('Cart-Drawer').classList.add('active');
          window.updateCartJson();
        }
      } else if (document.getElementById('Cart-Drawer')) {
        this.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');
        dispatchCustomEvent('cart-drawer:open');
        window.updateCartJson();
      }
    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}




/**
 *  @class
 *  @function ProductAddToCartSticky
 */
if (!customElements.get('product-add-to-cart-sticky')) {
  class ProductAddToCartSticky extends HTMLElement {
    constructor() {
      super();

      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      this.setupObservers();
      this.setupToggle();
      if (!this.dataset.comingSoon) {
        this.setupClickEvent();
      }
    }

    setupClickEvent = () => {
      var clickEvent = this.querySelector('a[data-variant-size]');
      if (clickEvent) {
        clickEvent.addEventListener('click', (e) => {
          var varSize = parseInt(e?.target?.getAttribute('data-variant-size') || 0);
          if (varSize != 0) {
            var form = document.getElementById(`ProductInfo-${this.dataset.section}`);
            if (form) {
              setTimeout(() => {
                form = form.querySelector('form');
                form.dispatchEvent(new Event('submit'));
              }, 1000);
            } 
          }
        })
      }
    }

    setupToggle() {
      const button = this.querySelector('.product-add-to-cart-sticky--inner'),
        content = this.querySelector('.product-add-to-cart-sticky--content');

      if (this.animations_enabled) {
        const tl = gsap.timeline({
          reversed: true,
          paused: true,
          onStart: () => {
            button.classList.add('sticky-open');
          },
          onReverseComplete: () => {
            button.classList.remove('sticky-open');
          }
        });

        tl
          .set(content, {
            display: 'block',
            height: 'auto'
          }, 'start')
          .from(content, {
            height: 0,
            duration: 0.25
          }, 'start+=0.001');

        button?.addEventListener('click', function () {
          tl.reversed() ? tl.play() : tl.reverse();

          return false;
        });
      } else {
        button?.addEventListener('click', function () {
          content.classList.toggle('active');
          return false;
        });
      }

    }
    setupObservers() {
      let _this = this,
        observer = new IntersectionObserver(function (entries) {
          entries.forEach((entry) => {
            if (entry.target === form) {
              let boundingRect = form.getBoundingClientRect();
              if (entry.intersectionRatio === 0 && window.scrollY > (boundingRect.top)) {
                _this.formPassed = true;
                _this.classList.add('sticky--visible');
              } else if (entry.intersectionRatio > 0) {
                _this.formPassed = false;
                _this.classList.remove('sticky--visible');
              }
            }
          });
        }, {
          threshold: [0, 1]
        }),
        // form = document.getElementById(`ProductInfo-${this.dataset.section}`),
        form = document.querySelector(`.product-price-container`),
        footer = document.getElementById('footer');
        _this.style.top = `${document.querySelector('#header')?.clientHeight || 135}px`;
      _this.formPassed = false;
      observer.observe(form);
      observer.observe(footer);
    }
  }

  customElements.define('product-add-to-cart-sticky', ProductAddToCartSticky);
}

/**
 *  @class
 *  @function ProductSidePanelLinks
 */
if (!customElements.get('side-panel-links')) {
  class ProductSidePanelLinks extends HTMLElement {
    constructor() {
      super();
      this.links = this.querySelectorAll('button');
      this.drawer = document.getElementById('Product-Information-Drawer');
      this.buttons = this.drawer.querySelector('.side-panel-content--tabs');
      this.panels = this.drawer.querySelector('.side-panel-content--inner').querySelectorAll('.side-panel-content--tab-panel');
      this.body = document.body;
    }
    connectedCallback() {
      this.setupObservers();
    }
    disconnectedCallback() {

    }
    setupObservers() {
      this.links.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          this.body.classList.add('open-cc');
          this.buttons.toggleActiveClass(i);
          this.drawer.classList.add('active');
        });
      });
    }
  }

  customElements.define('side-panel-links', ProductSidePanelLinks);
}


/**
 *  @class
 *  @function ProductCardSmall
 */
// if (!customElements.get('product-card-small')) {
//   class ProductCardSmall extends HTMLElement {
//     constructor() {
//       super();
//       if(!this.classList.contains('product-card-small-addon')) return;
//       this.submitButton = this.querySelector('button');
//       this.inputs = this.querySelectorAll('input, select');
//       this.select = this.querySelector('select');
//       if(this.submitButton) this.submitButton.addEventListener('click', this.onSubmitHandler.bind(this));
//     }

//     onSubmitHandler = (event) => {
//       var inputValue = this.querySelector('[name="items[][id]"]')?.value;
//       if (inputValue != "" && inputValue != null && inputValue != undefined) {
//         this.querySelector('[name="items[][id]"]')?.classList.remove('border-danger','border-3');
//         if (this.submitButton.classList.contains('addon-add')) {
//           this.submitButton.classList.remove('addon-add');
//           this.submitButton.classList.add('addon-added'); 
//           this.inputs.forEach(input => input.removeAttribute('disabled'));
//           this.classList.add("border-danger", "border-3");
//         } else {
//           this.submitButton.classList.add('addon-add');
//           this.submitButton.classList.remove('addon-added');
//           this.inputs.forEach(input => input.setAttribute('disabled', 'disabled'));
//           this.classList.remove("border-danger", "border-3");
//         }
//       } else {
//         this.querySelector('[name="items[][id]"]')?.classList.add('border-danger','border-3');
//         this.submitButton.classList.add('addon-add');
//         this.submitButton.classList.remove('addon-added');
//       }
//     }
//   }

//   customElements.define('product-card-small', ProductCardSmall);
// }

document.querySelectorAll('[data-open-accordion]').forEach((ele)=>{
  ele.addEventListener('click',(event)=>{
    let id = ele.getAttribute('data-open-accordion');
    if (window.innerWidth > 992) {
      document.querySelector(`${id} details:not([open]) summary`)?.click();
    } else {
      document.querySelector(`[data-mobile-content] ${id} details:not([open]) summary`)?.click();
      document.querySelector(`[data-mobile-content] ${id} details summary`).scrollIntoView({ behavior: 'smooth' });
    }
  })
})

document.addEventListener('DOMContentLoaded', (event) => {

  window.reInitModelsFunction = function() {
    // product newsletter model opener
    var openerTriggers = document.querySelectorAll('[data-model-opener]');
    if (openerTriggers.length) {
      openerTriggers.forEach((ele)=>{
        ele.addEventListener('click', function (e) {
          e.preventDefault();
          var triggerModel = ele?.getAttribute('data-model-opener');
          var model = document.querySelector(`#${triggerModel}`);
          if(!model) return;
          if (model.classList.contains('Product-Newsletter-Drawer')) {
            var hubspotForm = model.closest('hubspot-form');
            if (hubspotForm) {
              document.querySelector('#wrapper').appendChild(hubspotForm);
            }
          }
          model.classList.add('active');
          document.body.classList.add('open-cc--product');
        })
      })
    }
    var closeTriggers = document.querySelectorAll('[data-close-form-model]');
    if (closeTriggers.length) {
      closeTriggers.forEach(ele => {
        ele.addEventListener('click', function (e) {
          e.preventDefault();
          ele.closest('model-component')?.classList.remove('active');
          if(!ele.closest('[data-product-quick-view-model]')) {
            document.body.classList.remove('open-cc--product');
          }
        })
      })
    }
  }
  window.reInitModelsFunction();

  var dataProceedAtcBtn = document.querySelector('[data-proceed-atc]');
  if(dataProceedAtcBtn) {
    dataProceedAtcBtn.addEventListener('click', (e)=> {
      if(window.isProductCompatible == "No Data") {
        document.querySelector('model-component#NotSelected')?.classList.add('active');
        document.body.classList.add('open-cc--product');
      } else if (window.isProductCompatible == true) {
        if(!window.activeProductDataSectionId) return false;
        var prdForm = document.querySelector(`product-form[data-section="${window.activeProductDataSectionId}"]`);
        if (prdForm) {
          // prdForm.querySelector('form')?.dispatchEvent(new Event('final:submit'));
          window.checkWarrantyModel(prdForm.querySelector('form'));
          dataProceedAtcBtn.closest('model-component')?.classList.remove('active');
          document.body.classList.remove('open-cc--product');
        } 
      } else {
        dataProceedAtcBtn.closest('model-component')?.classList.remove('active');
        document.querySelector('model-component#NotCompatible')?.classList.add('active');
        document.body.classList.add('open-cc--product');
      }
    })
  }

  var dataNotCompatibleProceedAtc = document.querySelectorAll('[data-proceed-notcompatible-atc]');
  if (dataNotCompatibleProceedAtc) {
    dataNotCompatibleProceedAtc.forEach(item => {
      item.addEventListener('click', e => {
        if(!window.activeProductDataSectionId) return false;
        var prdForm = document.querySelector(`product-form[data-section="${window.activeProductDataSectionId}"]`);
        if (prdForm) {
          // prdForm.querySelector('form')?.dispatchEvent(new Event('final:submit'));
          window.checkWarrantyModel(prdForm.querySelector('form'));
          item?.closest('model-component')?.classList.remove('active');
          document.body.classList.remove('open-cc--product');
        } 
      })
    })
  }

  window.checkWarrantyModel = function (prdForm) {
    var showWarningModel = false;
    var selectedVehicleName = document.querySelector('[data-redirection-link]')?.href?.split('/vehicle-configuration/')[1] || null;
    if (selectedVehicleName) {
      if(prdForm.closest('#Product-Drawer')) {
        var modelFitmentMatchWarning = document.querySelector("#FitmentMatchWarning[data-product-quick-view-model]");
        const warningDataScript = prdForm.closest('#Product-Drawer')?.querySelector('script#warningPopupDataScript')?.textContent;
        if (warningDataScript) {
          eval(warningDataScript);
          if (!window.warrningPopupDataOfQuickView._apply_to_all_vehicle) {
            const vehicle = window.warrningPopupDataOfQuickView._vehicles_affected.filter(item => item === selectedVehicleName) || null; 
            if (vehicle.length > 0) {
              showWarningModel = true;  
            }
          }  else {
            showWarningModel = true;
          }
        }
      } else {
        var modelFitmentMatchWarning = document.querySelector("#FitmentMatchWarning[data-product-page-model]");
        if (!window.warrningPopupData._apply_to_all_vehicle) {
          const vehicle = window.warrningPopupData._vehicles_affected.filter(item => item === selectedVehicleName) || null; 
          if (vehicle.length > 0) {
            showWarningModel = true;  
          }
        }  else {
          showWarningModel = true;
        }
      }
    }
    if (showWarningModel) {
      setTimeout(() => {
        modelFitmentMatchWarning?.classList.add('active');
        document.body.classList.add('open-cc--product');
      }, 500);
    } else {
      prdForm?.dispatchEvent(new Event('final:submit'));
    }
  }

  window.warningModelAtcInit = function() {
    const warningForceAtc = document.querySelectorAll('[data-warrning-atc]');
    warningForceAtc?.forEach(item => {
      item.addEventListener('click', (e) => {
        if (window.activeProductDataSectionId) {
          var prdForm = document.querySelector(`product-form[data-section="${window.activeProductDataSectionId}"]`);
          if (prdForm) {
            prdForm.querySelector('form')?.dispatchEvent(new Event('final:submit'));
            item?.closest('model-component')?.classList.remove('active');
            document.body.classList.remove('open-cc--product');
          }  
        }
      })
    })
  }
  window.warningModelAtcInit();

  var dataSelectVehicleModel = document.querySelectorAll("[data-select-vehicle]");
  if (dataSelectVehicleModel) {
    dataSelectVehicleModel.forEach(item => {
      item.addEventListener("click", (e) => {
        e.preventDefault();
        item?.closest('model-component')?.classList.remove('active');
        var ymmModel = document.querySelector('#FindMyDevice');
        if (ymmModel) {
          ymmModel.classList.add('active');
        }
      })
    })
  }

  var dataYMMmodelGoBack = document.querySelectorAll('[data-ymm-model-goback]');
  if (dataYMMmodelGoBack) {
    dataYMMmodelGoBack.forEach(item => {
      item.addEventListener('click', e => {
        e.preventDefault();
        item?.closest('model-component')?.classList.remove('active');
        var notSelectedVehicle = document.querySelector('#NotSelected');
        if (notSelectedVehicle) {
          notSelectedVehicle.classList.add('active');
        }
      })
    })
  }

  window.renderCompolementryProducts = async function() {
    var cartRecommendedProducts = document.querySelector('[data-cart-complementary-products]');
    if (cartRecommendedProducts) {
      var vehicleConfiguration = localStorage.getItem('vehicle_configuration');
      if (vehicleConfiguration) {
        var vehicleConfiguration = JSON.parse(vehicleConfiguration)[0];
        if (vehicleConfiguration?.vehicle_categories_url != undefined) {
          var vehicle_categories_url = vehicleConfiguration?.vehicle_categories_url;
          
          const response = await fetch(`${vehicle_categories_url}?view=side-cart-product-recommendation`);
          const data = await response.text();    
          const firstLineItemUpsell = cartRecommendedProducts.querySelector('.lineitem-complementary');
          if(firstLineItemUpsell) {
            firstLineItemUpsell.insertAdjacentHTML('afterend', data);
          } else {
            cartRecommendedProducts.insertAdjacentHTML('afterbegin', data);
          }
          var limit = parseInt(document.querySelector('[data-cart-complementray-limit]')?.getAttribute('data-cart-complementray-limit') || 10);
          if (limit) {
            cartRecommendedProducts.querySelectorAll('.complementray-product-card').forEach((el, index) => {
              ++index;
              if (index > limit) {
                el.classList.add('d-none');  // Add 'd-none' class to elements after the 10th
              }
            })
          }

        }      
      }
    }
  }
  window.renderCompolementryProducts();


  // function to make right side sticky
  if (__st.p == "product") {
    var skuSelector = document.querySelector('[data-sku-copy-model]');
    if (skuSelector != null) {
      skuSelector.addEventListener('copy', function() {
        var skuDiscountModelCopyTitle = document.querySelector('#SKUDiscount .copy-btn-title');
        skuDiscountModelCopyTitle && (skuDiscountModelCopyTitle.innerHTML = "Click to Copy");
        document.querySelector('#SKUDiscount')?.classList.add('active');
        fetch("https://bv-prd.api.sultans.co/public/discounts", {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
        })
        .then(response => response.json())
        .then(data => {
          if (data?.code) {
            document.querySelector('#sku-discount-code').innerHTML = data.code;
          }
        })
        .catch(e => {
          console.error('sku discount', e);
        });
        document.body.classList.add('open-cc--product');
      });
    }

    var skuDiscountModel = document.querySelector('#SKUDiscount');
    if (skuDiscountModel) {
      var skuDiscountModelCode = skuDiscountModel.querySelector('.discount-code-wrapper');
      var skuDiscountModelButton = skuDiscountModel.querySelector('button');
      var skuDiscountModelCopyTitle = skuDiscountModel.querySelector('.copy-btn-title');
      if (skuDiscountModelCode != null && skuDiscountModelButton != null) {
        skuDiscountModelButton?.addEventListener('click', function() {
          var discountCode = skuDiscountModelCode.innerText;
          var tempInput = document.createElement('input');
          tempInput.value = discountCode;
          document.body.appendChild(tempInput);
          tempInput.select();
          tempInput.setSelectionRange(0, 99999);
          document.execCommand('copy');
          document.body.removeChild(tempInput);
          skuDiscountModelCopyTitle && (skuDiscountModelCopyTitle.innerHTML = "Copied!");
        });
      }
    }
  }
})